import { render, staticRenderFns } from "./Sendsecretcodes.vue?vue&type=template&id=0c16b0be"
import script from "./Sendsecretcodes.vue?vue&type=script&lang=js"
export * from "./Sendsecretcodes.vue?vue&type=script&lang=js"
import style0 from "./Sendsecretcodes.vue?vue&type=style&index=0&id=0c16b0be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports